import React from 'react';
import { CheckCircle, AlertCircle } from 'lucide-react';
interface UpcomingScreeningsProps {
  screenings: {
    name: string;
    position: string;
    time: string;
    status: string;
  }[];
}
export const UpcomingScreenings = ({
  screenings
}: UpcomingScreeningsProps) => {
  return <div className="space-y-4" data-id="element-1765">
      {screenings.map((screening, index) => <div key={index} className="border border-gray-200 rounded-lg p-4" data-id="element-1766">
          <div className="flex justify-between items-start mb-2" data-id="element-1767">
            <div data-id="element-1768">
              <h4 className="font-medium" data-id="element-1769">{screening.name}</h4>
              <p className="text-sm text-gray-500" data-id="element-1770">{screening.position}</p>
            </div>
            {screening.status === 'Confirmed' ? <CheckCircle size={16} className="text-green-500" data-id="element-1771" /> : <AlertCircle size={16} className="text-yellow-500" data-id="element-1772" />}
          </div>
          <div className="text-sm text-gray-600" data-id="element-1773">
            <p data-id="element-1774">{screening.time}</p>
            <p className="mt-1" data-id="element-1775">{screening.status}</p>
          </div>
          <div className="mt-3 flex space-x-2" data-id="element-1776">
            <button className="bg-indigo-600 text-white px-3 py-1 rounded text-sm" data-id="element-1777">
              Prepare
            </button>
            <button className="border border-gray-300 text-gray-600 px-3 py-1 rounded text-sm" data-id="element-1778">
              {screening.status === 'Confirmed' ? 'Reschedule' : 'Confirm'}
            </button>
          </div>
        </div>)}
    </div>;
};